export default "__VITE_ASSET__BqbSef91__"